import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';

interface IEditNotificationModalContext {
  title: string;
  data: any;
}

@Component({
  selector: 'app-edit-alert-notification',
  templateUrl: './edit-alert-notification-modal.component.html',
  styleUrls: ['./edit-alert-notification-modal.component.scss'],
})
export class EditAlertNotificationComponent {
  editForm: FormGroup;

  constructor(
    public modal: SuiModal<IEditNotificationModalContext, void, void>,
    private fb: FormBuilder
  ) {
    this.editForm = fb.group({
      notificationName: ['', Validators.required],
      email: ['', Validators.required],
      subject: ['', Validators.required],
      description: ['', Validators.required],
    });
  }
}

export class EditAlertNotificationModal extends ComponentModalConfig<
  IEditNotificationModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Mini) {
    super(EditAlertNotificationComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
